import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'
import { FullScreenLoader } from '@/components/FullScreenLoader'

export function DashboardRouteGuard({ children }: { children: React.ReactNode }) {
  const { data: isInstitutionStaff, isLoading, isError } = useQuery({
    queryKey: ['is_institution_staff'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_institution_staff' as any)
      if (error) throw error
      return data as boolean
    },
    retry: false,
  })

  if (isLoading) return <FullScreenLoader />

  // A failed request (e.g. an invalid/expired session token) is not the
  // same as a confirmed "you're not staff" — treating it that way sent
  // the user to /admin, whose guard fails the same way and bounces them
  // to /auth, which redirects them right back here: an infinite loop.
  // Clear the broken session instead so they land on a clean sign-in
  // screen and the loop can't restart.
  if (isError) {
    supabase.auth.signOut()
    return <Navigate to="/auth?mode=signin" replace />
  }

  // Super admins who navigate to /dashboard are redirected to /admin
  if (!isInstitutionStaff) return <Navigate to="/admin" replace />

  return <>{children}</>
}
